
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import styled from 'styled-components';
// import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md';

// const SidebarLink = styled(Link)`
//   display: flex;
//   color: rgba(36, 34, 32, 0.6) !important;
//   justify-content: space-between;
//   align-items: center;
//   padding: 20px;
//   list-style: none;
//   height: 60px;
//   text-decoration: none;
//   font-size: 18px;
//   &:hover {
//     background: #f4f2e5;
//     border-left: 4px solid #f4de58;
//     cursor: pointer;
//     color: rgba(36, 34, 32, 0.6);
//   }
// `;

// // const SidebarLabel = styled.span`
// //   margin-left: 12px;
// // `;

// const DropdownLink = styled(Link)`
//   height: 40px;
//   padding-left: rem;
//   display: flex;
//   text-align: left;
//   background: #fff;
//   align-items: center;
//   text-decoration: none;
//   color: rgba(36, 34, 32, 0.6) !important;
//   font-size: 14px;
//   &:hover {
//     cursor: pointer;
//     color: rgba(36, 34, 32, 0.6) !important;
//   }
// `;

// const SubMenu = ({ item, openDropdownIndex, setOpenDropdownIndex, handleCloseDropdown }) => {
//   const handleItemClick = (index) => {
//     setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
//   };

//   return (
//     <>
//       <SidebarLink to={item.path} onClick={() => handleItemClick(item.index)}>
//         <div>
//           <img src={item.icon} alt="" />
//           <SidebarLabel style={{ fontSize: '17px' }}>{item.title}</SidebarLabel>
//         </div>
//         <div className="dropdownns">
//           {item.subNav && openDropdownIndex === item.index
//             ? item.iconOpened
//             : item.subNav
//             ? item.iconClosed
//             : null}
//         </div>
//       </SidebarLink>
//       {item.subNav && openDropdownIndex === item.index && (
//         <div>
//           {item.subNav.map((subItem, index) => (
//             <DropdownLink to={subItem.path} key={index}>
//               <SidebarLabel style={{ marginLeft: '34px', width: '220px' }}>
//                 <input
//                   style={{
//                     marginLeft: '-18px',
//                     marginTop: '4px',
//                     cursor: 'pointer',
//                   }}
//                   type="radio"
//                   variant="success"
//                 />
//                 {subItem.title}
//               </SidebarLabel>
//             </DropdownLink>
//           ))}
//         </div>
//       )}
//       {openDropdownIndex !== null && <div className="overlay" onClick={handleCloseDropdown} />}
//     </>
//   );
// };

// export default SubMenu;

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const SubMenu = ({ item, openDropdownIndex, setOpenDropdownIndex, handleCloseDropdown }) => {
  const handleItemClick = (index) => {
    setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <SidebarLink 
        to={item.path} 
        onClick={() => handleItemClick(item.index)}
        $isActive={openDropdownIndex === item.index}
      >
        <IconTitleWrapper>
          <MenuIcon src={item.icon} alt="" />
          <SidebarLabel>{item.title}</SidebarLabel>
        </IconTitleWrapper>
        <DropdownIcon>
          {item.subNav && openDropdownIndex === item.index
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </DropdownIcon>
      </SidebarLink>
      {item.subNav && openDropdownIndex === item.index && (
        <DropdownContainer>
          {item.subNav.map((subItem, index) => (
            <DropdownLink 
              to={subItem.path} 
              key={index}
              onClick={handleCloseDropdown}
            >
              <RadioContainer>
                <HiddenRadioInput type="radio" name="submenu" />
                <StyledRadioInput $checked={false} />
                <DropdownLabel>{subItem.title}</DropdownLabel>
              </RadioContainer>
            </DropdownLink>
          ))}
        </DropdownContainer>
      )}
    </>
  );
};

// Styled Components
const SidebarLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  color: rgba(36, 34, 32, 0.6);
  text-decoration: none;
  border-radius: 5px;
  margin-bottom: 5px;
  transition: all 0.3s ease;
  background: ${({ $isActive }) => $isActive ? '#f4f2e5' : 'transparent'};
  border-left: ${({ $isActive }) => $isActive ? '4px solid #f4de58' : 'none'};

  &:hover {
    background: #f4f2e5;
    border-left: 4px solid #f4de58;
    color: rgba(36, 34, 32, 0.6);
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
  }
`;

const IconTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MenuIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 12px;

  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
`;

const SidebarLabel = styled.span`
  font-size: 14px;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const DropdownIcon = styled.div`
  display: flex;
  align-items: center;
`;

const DropdownContainer = styled.div`
  margin-left: 20px;
  margin-bottom: 5px;
  border-radius: 5px;
  overflow: hidden;
`;

const DropdownLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 8px 15px;
  color: rgba(36, 34, 32, 0.6);
  text-decoration: none;
  font-size: 13px;
  transition: all 0.2s ease;
  background: #fff;

  &:hover {
    color: rgba(174, 101, 28, 0.6);
    background: #f9f9f9;
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 12px;
  }
`;

const RadioContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
`;

const HiddenRadioInput = styled.input.attrs({ type: 'radio' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const StyledRadioInput = styled.span`
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc;
  border-radius: 50%;
  margin-right: 10px;
  transition: all 0.2s;

  ${RadioContainer}:hover & {
    border-color: #888;
  }

  ${HiddenRadioInput}:checked + & {
    border-color: #14ae78;
    background-color: #14ae78;
  }

  ${HiddenRadioInput}:checked + &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: white;
  }
`;

const DropdownLabel = styled.span`
  flex: 1;
  font-size: 13px;
  margin-left: 5px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export default SubMenu;
